import React, {useEffect, useState} from "react";
import './pagePayment.css'
import RecapPayment from "./recapPayment";
import { IoIosCloseCircleOutline } from "react-icons/io";
import TopBarPayment from "./topBarPayment";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CommandProps } from "../../components/types/types";
const PageRefuse = () => {
    const [searchParams] = useSearchParams();

    const navigate = useNavigate();
    const [valueCommand,setValueCommand] = useState<CommandProps[]>([])
    const [show,setShow] = useState(false)
    useEffect(() => {
        const token = searchParams.get("token");

        if (!token) {
            navigate("/"); 
            return;
        }
        const validtoken = async () => {
            try {
                const result = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/verify_payment_token`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                    body: JSON.stringify({token: token}),
                });
        
                if (!result.ok) {
                    navigate("/"); 
                }
                
                const data = await result.json()
                if (!data.valid) {
                    navigate("/"); 
                } else {
                    const { command, ref, auto, erreur } = data.payload;
                    setShow(true)
                    setValueCommand(command)
                    const timer = setTimeout(() => {
                       navigate(-2);
                    }, 10000);
                    return () => clearTimeout(timer);
                }
            }
            catch {
                navigate("/"); 
        }}
        validtoken()

    }, [navigate, searchParams]);

    return(
        <div className="pageRefuse">
            <TopBarPayment />
            {show && <>
                <div className="largeTitle">Paiement refusé <IoIosCloseCircleOutline size={30} color="red"/> </div>   
                <RecapPayment command={valueCommand} isValid={false}/>

                <p className="smallText textExplain">Votre paiement a été refusé.</p>
                <p className="smallText textExplain">Vous allez être redirigé vers la page précédente pour réessayer ou modifier votre saisie.</p>

                <p className="smallText waitingText">Veuillez patienter quelques instants...</p>
           </>}
        </div>
    )
}

export default PageRefuse